/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkUserItem } from './BulkUserItem';
import {
    BulkUserItemFromJSON,
    BulkUserItemFromJSONTyped,
    BulkUserItemToJSON,
    BulkUserItemToJSONTyped,
} from './BulkUserItem';

/**
 * Bulk user provisioning request
 * @export
 * @interface BulkUserProvisionRequest
 */
export interface BulkUserProvisionRequest {
    /**
     * List of users to provision
     * @type {Array<BulkUserItem>}
     * @memberof BulkUserProvisionRequest
     */
    users: Array<BulkUserItem>;
    /**
     * Tenant ID where users will be provisioned
     * @type {string}
     * @memberof BulkUserProvisionRequest
     */
    tenantId: string;
    /**
     * Default role to assign to all users (overrides individual role if not specified)
     * @type {string}
     * @memberof BulkUserProvisionRequest
     */
    defaultRole?: string;
    /**
     * Whether to assign temporary passwords (local auth only)
     * @type {boolean}
     * @memberof BulkUserProvisionRequest
     */
    temporaryPassword?: boolean;
    /**
     * Whether to skip users that already exist
     * @type {boolean}
     * @memberof BulkUserProvisionRequest
     */
    skipExisting?: boolean;
}

/**
 * Check if a given object implements the BulkUserProvisionRequest interface.
 */
export function instanceOfBulkUserProvisionRequest(value: object): value is BulkUserProvisionRequest {
    if (!('users' in value) || value['users'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function BulkUserProvisionRequestFromJSON(json: any): BulkUserProvisionRequest {
    return BulkUserProvisionRequestFromJSONTyped(json, false);
}

export function BulkUserProvisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUserProvisionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'users': ((json['users'] as Array<any>).map(BulkUserItemFromJSON)),
        'tenantId': json['tenantId'],
        'defaultRole': json['defaultRole'] == null ? undefined : json['defaultRole'],
        'temporaryPassword': json['temporaryPassword'] == null ? undefined : json['temporaryPassword'],
        'skipExisting': json['skipExisting'] == null ? undefined : json['skipExisting'],
    };
}

export function BulkUserProvisionRequestToJSON(json: any): BulkUserProvisionRequest {
    return BulkUserProvisionRequestToJSONTyped(json, false);
}

export function BulkUserProvisionRequestToJSONTyped(value?: BulkUserProvisionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users': ((value['users'] as Array<any>).map(BulkUserItemToJSON)),
        'tenantId': value['tenantId'],
        'defaultRole': value['defaultRole'],
        'temporaryPassword': value['temporaryPassword'],
        'skipExisting': value['skipExisting'],
    };
}

